import React from "react";
import { MessageCircle } from "lucide-react";
import { waLink } from "../lib/api";

export default function WhatsAppFloat() {
  return (
    <a
      data-testid="whatsapp-float"
      href={waLink("Hello Faisal Car Bazar! I'd like to enquire about your cars.")}
      target="_blank"
      rel="noopener noreferrer"
      className="fixed bottom-6 right-6 md:bottom-8 md:right-8 z-40 bg-[#25D366] text-white w-14 h-14 md:w-16 md:h-16 rounded-full flex items-center justify-center shadow-2xl wa-pulse hover:scale-110 transition-transform"
      aria-label="Chat on WhatsApp"
    >
      <MessageCircle size={26} strokeWidth={2.2} />
    </a>
  );
}
